/** @module components/paywalls */
import SpacesLimit from './SpacesLimit';

export default SpacesLimit;
